import { Component, OnInit, ViewChild, ElementRef, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal: any;
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MustMatch } from '../helper/must-match.validator';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-addusermanagement',
  templateUrl: './addusermanagement.component.html',
  styleUrls: ['./addusermanagement.component.css']
})
export class AddusermanagementComponent implements OnInit {
  returnUrl = "/dashboard/usermanagement";
  farmuservalue: any;
  getlistApi: any;
  getfarmvalue: any;
  adduserFormValue: any;
  addUrl: any;
  registerForm: FormGroup;
  getfarmsListData: any;
  subscription: Subscription;
  submitted = false;
  isLoading = false;
  finalval: any = [];
  getuserListData: any = [];
  constructor(private router: Router, private commonService: CommonService, private formBuilder: FormBuilder, private elementRef: ElementRef, @Inject(DOCUMENT) private doc) { }

  async ngOnInit() {
    /* var s14 = document.createElement("script");
     s14.type = "text/javascript";
     s14.src = "assets/js/bootstrap.min.js";
     this.elementRef.nativeElement.appendChild(s14);
     var s15 = document.createElement("script");
     s15.type = "text/javascript";
     s15.src = "assets/js/core/jquery-3.5.1.js";
     this.elementRef.nativeElement.appendChild(s15);
     var s16 = document.createElement("script");
     s16.type = "text/javascript";
     s16.src = "assets/js/core/popper.min.js";
     this.elementRef.nativeElement.appendChild(s16);
     var s17 = document.createElement("script");
     s17.type = "text/javascript";
     s17.src = "assets/js/material-dashboard.min6c54.js";
     this.elementRef.nativeElement.appendChild(s17);
     let link1: HTMLLinkElement = this.doc.createElement('link');
     link1.setAttribute('rel', 'html');
     link1.setAttribute('href', '../assets/css/material-dashboard.min6c54.css?v=2.2.2');
     this.doc.head.appendChild(link1);*/
    ////
    this.getlistApi = "/user_management";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {

        this.getuserListData = res.data.map(function (elem) {
          return {
            email: elem.tnus_email.toLowerCase(),
            // userid: elem.tnus_user_code.toLowerCase()
          };
        });
        console.log(this.getuserListData)
      })
    $('.selectpicker').selectpicker('refresh');
    this.registerForm = this.formBuilder.group({
      username: ['', {
        validators: [Validators.required], updateOn: 'blur'
      }],
      userid: ['', {
        validators: [Validators.required], updateOn: 'blur'
      }],
      email: ['', { validators: [Validators.compose([Validators.required, Validators.email, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])], updateOn: 'blur' }],
      mobileNumber: ['', [Validators.required, Validators.pattern("[0-9]{10,12}")]],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    },/*{validator: this.passwordMatchValidator}*/{
      validator: MustMatch('password', 'confirmPassword')
    });

    $(document).on('change', '#userrole', function () {
      $('.myFakeClass').setAttribute("aria-expanded", false);
      $('#userrole .dropdown-menu').removeClass('show');
    });

    /* $(document).on('change', '#farmname', function(){
    $('.myFakeClass').setAttribute("aria-expanded", false);
   $('.dropdown-menu').removeClass('show');
     $('.myFakeClass').dropdown('toggle');
    });*/
    $(document).on('change', '#myfakeclass3', function () {
      $('.myfakeclass3').dropdown('toggle');
      $('.myFakeClass').dropdown('toggle');
    });

  }
  uniquecheckvalidation(e) {
    this.finalval = [];
    var userrecordforcheck = e.target.value.toLowerCase();
    console.log(this.getuserListData)
    let sameemail = this.getuserListData.filter((user) => user.email == userrecordforcheck);
    if (sameemail.length) {
      this.finalval.push(sameemail)
      Swal.fire("Duplicate values", 'User Email already Exist');
    }
  }
  uniquecheckvalidationid(e) {
    this.finalval = [];
    var userrecordforcheck = e.target.value.toLowerCase();
    console.log(userrecordforcheck)
    let sameid = this.getuserListData.filter((user) => user.userid == userrecordforcheck);
    if (sameid.length) {
      this.finalval.push(sameid)
      Swal.fire("Duplicate values", 'User Id already Exist');
    }
  }
  get f() { return this.registerForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    // display form values on success
    this.usermanagement()
  }
  async farmuser(e) {
    this.farmuservalue = e.target.value;
    if (this.farmuservalue != ('Farm user')) {
      return;
    }
    else {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      },)
      this.getlistApi = "/farms";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        (res) => {
          this.getfarmsListData = res.data;
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          }, 1000);
        })

    }

  }
  selectfarmuser(e) {
    // $('#userrole').parents('.dropdown').find('.dropdown-menu').removeClass('show')
    this.getfarmvalue = e.target.value
  }
  async usermanagement() {
    this.adduserFormValue = {
      "role": $('#userrole').val(),
      "name": $('#username').val(),
      "email": $('#useremail').val(),
      "user_code": $('#userid').val(),
      "contact_no": $('#usercontact').val(),
      "department": $('#userdepartment').val(),
      "status": $('#status').val(),
      "password": $('#pswd').val(),
      "farm_id": this.getfarmvalue
    };
    console.log(this.adduserFormValue)
    if (this.finalval.length) {
      Swal.fire("Duplicate values", 'Userid or Email already Exist');
    } else {

      this.addUrl = "/user_management";
      (await this.commonService.postApi(this.addUrl, this.adduserFormValue)).subscribe(
        data => {
          console.log(data.message);
          var mess = data.message;
          if (mess.includes('ER_')) {
            alert("User ID already exists");
          } else {

            setTimeout(
              (): void => {

                this.router.navigate([this.returnUrl]);

              },
              500
            );
          }
          alert("Data added successfully")
        },
        err => {
          Swal.fire("Duplicate values", 'User Id already Exist');
        });
    }
  }

  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
